/**
 * @title 婚纱摄影旅拍景点相关业务
 */

import CommonApi from '@api/common'
import Api from '@api/kong_kong/CardAddApi'
import { action, observable } from 'mobx'

class Store {
  // 婚纱摄影类目 propertyId = 6 案例基础信息-拍摄城市相关业务
  @observable allCity = [] // 全部城市
  @observable scenicSpot = [] // 婚纱摄影 - 拍摄景点
  @observable cityName = [] // 婚纱摄影 - 城市名称
  @observable scenic_spot_cid = '' // 景点城市id
  @observable spotId = undefined // 选中景点id
  @observable spotName = '' // 景点名称

  /**
   * @title 获取全部城市信息 用于 propertyId = 6 婚纱摄影类目 拍摄城市
   */
  @action
  getAllCity = async () => {
    const { data } = await CommonApi.getCityApi()
    const proviceCity = data.map(item => {
      const province = {
        value: item.pid,
        label: item.name,
        key: item.pid
      }
      if (item.city) {
        province.children = item.city.map(item => ({
          value: item.name,
          label: item.name,
          key: item.cid
        }))
      }
      return province
    })
    this.allCity = proviceCity
  }

  /**
   * @title 切换城市
   */
  @action
  changeCity = setFieldsValue => async (value, selectedOptions) => {
    this.cityName = value
    this.spotId = undefined
    setFieldsValue({ spotId: undefined })

    if (selectedOptions.length) {
      this.getScenicSpotByCityCode(selectedOptions[1].key)
      this.scenic_spot_cid = selectedOptions[1].key
    } else {
      this.spotName = ''
      setFieldsValue({ spotName: '' })
    }
  }

  /**
   * @title 根据城市 code 获取对应城市景点列表
   */
  @action
  getScenicSpotByCityCode = async cityCode => {
    if (!cityCode) {
      return
    }
    let params = {
      cityCode,
      isAll: false
    }

    const {
      data: { list },
      success
    } = await Api.getByCityCode(params)
    if (success) {
      this.scenicSpot = list
    }
  }

  /**
   * @title 切换景点
   */
  @action
  changeScenicSpot = setFieldsValue => (value, option) => {
    this.spotId = value
    setFieldsValue({ spotName: '' })
    if (value != '0') {
      if (option) {
        this.spotName = option.props.children
      } else {
        this.spotName = ''
      }
    } else {
      this.spotName = ''
    }
  }

  /**
   * @title 切换景点名称
   */
  @action
  changeSpotName = e => {
    this.spotName = e.target.value
  }
}

export default Store
